import type { FaireProductEntity } from "../../entity_types/product";

export const p_9dvfwx8gkw: FaireProductEntity = {
  token: "p_9dvfwx8gkw",
  type: "product",
  name: "La Seine Crew Socks",
  brandToken: "b_46c570c5",
  brandName: "Solmate Socks",
  imageUrl:
    "https://cdn.faire.com/fastly/5f62d305f5a60422b4f5d81302dfa397a64e72ee9d1463356f9e79b19d02ebe5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9bf86af3b7f93d026afd4b129e831bcb074492b4257fa24de71b1697f8ed6c75.jpeg",
    "https://cdn.faire.com/fastly/84b6c568cff7432de8cb7988dbd0ff228bb504f95aee19ad28575ef3bd5d8a5e.jpeg",
  ],
  priceDollars: 9.25,
  description:
    "Colors in this Sock: Purple, Black, Lilac, Teal, and Army Green.\n\nMade With: 62% Recycled Cotton, 22% Recycled Polyester, 15% Nylon, 1% Spandex\n\n",
  tags: [],
  msrpDollars: 19.95,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:34.059Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
